import React from 'react';
import { useLingui } from '@lingui/react/macro';

import verifyEmailSvg from '@rover/react-lib/src/images/account/email-verification/verify-email.svg?url';
import type { EmailVerification } from '@rover/types/src/EmailVerification';
import { EmailVerificationStatus } from '@rover/types/src/EmailVerification';
import inject from '@rover/utilities/injector';

import { HEADER_TEXT, IMAGE_HEADER_CONTENT } from './components/content.constants';
import VerifyEmail from './components/VerifyEmail';

type Props = {
  isSubmitting: boolean;
  verifyStatus: number | null;
  resendStatus: number | null;
  errorMessage: string;
  diagnosticErrorMessage: string;
  verifyEmail: (arg0: EmailVerification) => void;
  resendCode: (refresh?: boolean) => void;
  logoutCurrentUser: (arg0: { nextLocation: string; ref?: string }) => void;
};

const EmailVerificationPage = (props: Props): JSX.Element => {
  const { t, i18n } = useLingui();
  const userEmail = inject('Rover.context.currentEmailAddress', '');
  const isBlockingModal = inject('Rover.context.isBlockingModal', false);
  const emailVerificationStatus = inject('Rover.context.emailVerificationStatus', '');

  const isCompulsory =
    emailVerificationStatus === EmailVerificationStatus.COMPULSORY || isBlockingModal;

  const formLabel = t`Verification code`;
  const placeholderText = t`Enter the code from email`;
  const verifyButtonText = t`Verify your email`;
  const verifyingButtonText = t`Verifying email`;
  const resendButtonText = t`Send new code`;
  const skipButtonText = t`Skip for now`;
  const verifiedText = t`Email verified!`;

  return (
    <VerifyEmail
      headerText={i18n._(HEADER_TEXT(isCompulsory))}
      imageHeaderContent={i18n._(IMAGE_HEADER_CONTENT(userEmail, isCompulsory))}
      formLabel={formLabel}
      placeholderText={placeholderText}
      image={verifyEmailSvg}
      verifyButtonText={verifyButtonText}
      verifyingButtonText={verifyingButtonText}
      resendButtonText={resendButtonText}
      skipButtonText={skipButtonText}
      verifiedText={verifiedText}
      isBlockingModal={isBlockingModal}
      emailVerificationStatus={emailVerificationStatus}
      {...props}
    />
  );
};

export default EmailVerificationPage;
